import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { Store, Select } from '@ngxs/store';

import * as actions from './court-event-modals.actions';
import { CourtEventModalsSelectors } from './court-event-modals.selectors';

@Injectable({ providedIn: 'root' })
export class CourtEventModalsFacade {
    
    @Select(CourtEventModalsSelectors.isCancelReasonFormLoading) isCancelFormLoading$: Observable<boolean>;
    @Select(CourtEventModalsSelectors.isCancelReasonFormValid) isCancelFormValid$: Observable<boolean>;
    @Select(CourtEventModalsSelectors.isCancelBlockedSlotFormLoading) isCancelBlockedSlotFormLoading$: Observable<boolean>;
    @Select(CourtEventModalsSelectors.isCancelBlockedSlotFormValid) isCancelBlockedSlotFormValid$: Observable<boolean>;

    constructor(private store: Store) {}
  
    cancelCourtBooking = (courtBookingId: string) => this.store.dispatch(new actions.CancelCourtBookingAction(courtBookingId));
    cancelBlockedSlot = (blockedSlotId: string) => this.store.dispatch(new actions.CancelBlockedSlotAction(blockedSlotId));
}
